import { useWorkflowShowStore } from "@/features/maintenance/features/workflows/stores/workflowShowStore";
import MaintenanceEstablishmentChoiceManualEntryProposalEstablishmentAccept from "./manualEntryProposal/EstablishmentAccept";
import MaintenanceEstablishmentChoiceManualEntryProposalEstablishmentReject from "./manualEntryProposal/EstablishmentReject";

const MaintenanceWorkflowActionsOnGoingEstablishmentChoice = () => {
  const { forwarding } = useWorkflowShowStore();

  const ProposalStatus = forwarding?.establishment_choice_entry?.actual_proposal?.status;

  if (ProposalStatus === 'awaiting_establishment_response') {
    return (
      <div className="flex gap-3">
        <MaintenanceEstablishmentChoiceManualEntryProposalEstablishmentReject
          forwarding={forwarding!}
        />

        <MaintenanceEstablishmentChoiceManualEntryProposalEstablishmentAccept
          forwarding={forwarding!}
        />
      </div>
    );
  }

  return null;
}

export default MaintenanceWorkflowActionsOnGoingEstablishmentChoice;
